/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Svg } from 'app/components';
import { useTranslation } from 'react-i18next';
import { FavBtn } from './styles';

const propTypes = {
  id: PropTypes.string.isRequired,
  favorite: PropTypes.bool.isRequired,
  loyaltyCode: PropTypes.string.isRequired,
  favoriteList: PropTypes.arrayOf(PropTypes.string).isRequired,
  withBookmark: PropTypes.bool,

  requestToggleFavorite: PropTypes.func.isRequired
};

const defaultProps = {
  withBookmark: false
};

const FavoriteBtn = ({
  id,
  favorite,
  loyaltyCode,
  requestToggleFavorite,
  withBookmark,
  favoriteList
}) => {
  const [t] = useTranslation();
  const [isPending, togglePending] = useState(false);
  const [isFavorite, toggleFavorite] = useState(favorite);

  const send = useCallback(() => {
    togglePending(true);

    requestToggleFavorite({
      id,
      favorite: !isFavorite,
      loyaltyCode
    });
  }, [isFavorite]);

  useEffect(() => {
    if (!isPending) return;

    const isNewFavorite = favoriteList.indexOf(loyaltyCode) >= 0;

    togglePending(false);
    toggleFavorite(isNewFavorite);
  }, [favoriteList, isFavorite]);

  const setClassName = () => {
    if (isFavorite && isPending) {
      return '_selected _pending';
    }

    if (!isFavorite && isPending) {
      return '_pending';
    }

    if (isFavorite) {
      return '_selected';
    }

    return null;
  };

  return (
    <FavBtn
      className={setClassName()}
      onClick={send}
      title={isFavorite ? t('cinemas.fav_remove') : t('cinemas.fav_add')}
      withBookmark={withBookmark}
    >
      {withBookmark ? <Svg id="bookmark" /> : null}

      <Svg id="star" />
    </FavBtn>
  );
};

FavoriteBtn.defaultProps = defaultProps;
FavoriteBtn.propTypes = propTypes;
export default FavoriteBtn;
